// src/Components/CareerProgressBar.jsx
import React from 'react';

const levels = ['Lv 1', 'Lv 2', 'Lv 3', 'Lv 4', 'Lv 5'];

const CareerProgressBar = ({ currentLevel = 1 }) => {
  return (
    <div className="w-full flex flex-col items-center gap-3 mb-6">
      {/* Levels */}
      <div className="flex justify-between w-full max-w-[700px]">
        {levels.map((level, index) => {
          const isActive = index + 1 === currentLevel;
          return (
            <div
              key={level}
              className={`px-3 py-1 rounded-md text-sm font-bold text-center 
                ${isActive ? 'bg-green-500 text-white' : 'bg-gray-200 text-gray-600'}`}
            >
              {level}
            </div>
          );
        })}
      </div>

      {/* Progress bar */}
      <div className="w-full max-w-[700px] h-2 bg-gray-300 rounded-full">
        <div
          className="h-2 bg-green-500 rounded-full transition-all duration-500"
          style={{ width: `${(currentLevel / levels.length) * 100}%` }}
        />
      </div>
    </div>
  );
};

export default CareerProgressBar;
